import { IContext } from 'rc-app/types';
import React from 'react';

export const ClientContext = React.createContext({} as IContext);
